import React, { Component } from 'react';
import { translate } from 'react-i18next';
import config from '../config';

import { Table, Checkbox, Button } from 'react-bootstrap';
import Moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import TooltipButton from './TooltipButton';

import './TemplateMediaTable.css';

class TemplateMediaTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDragging: false,
			medialibraryuuid: this.props.medialibraryuuid,
			organisationuuid: this.props.organisationuuid,
			media: this.props.media || [],
			itemsSelected: this.props.itemsSelected,
			editingMediaUuid: null,
			editingName: '',
			editingFolderUuid: null,
			editingFolderName: ''
		};
		// Where within a media row the pointer grabbed it — used to keep the
		// shrunk drag pill under the cursor (rbd v9 has no renderClone).
		this.grabOffset = { x: 24, y: 22 };
	}

	recordGrab = (e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		this.grabOffset = { x: e.clientX - rect.left, y: e.clientY - rect.top };
	};

	// --- inline rename: media ---
	startEditingName = (media, e) => {
		e.stopPropagation();
		this.setState({ editingMediaUuid: media.uuid, editingName: media.name });
	};

	handleNameChange = (e) => {
		this.setState({ editingName: e.target.value });
	};

	handleNameKeyDown = (media, e) => {
		if (e.key === 'Enter') {
			this.saveNameEdit(media);
		} else if (e.key === 'Escape') {
			this.cancelNameEdit();
		}
	};

	saveNameEdit = (media) => {
		const newName = this.state.editingName.trim();
		if (newName && newName !== media.name && this.props.onRenameMedia) {
			this.props.onRenameMedia(media, newName);
		}
		this.setState({ editingMediaUuid: null, editingName: '' });
	};

	cancelNameEdit = () => {
		this.setState({ editingMediaUuid: null, editingName: '' });
	};

	// --- inline rename: sub-folder ---
	startEditingFolder = (folder, e) => {
		e.stopPropagation();
		e.preventDefault();
		this.setState({ editingFolderUuid: folder.uuid, editingFolderName: folder.name });
	};

	handleFolderNameChange = (e) => {
		this.setState({ editingFolderName: e.target.value });
	};

	handleFolderNameKeyDown = (folder, e) => {
		if (e.key === 'Enter') {
			this.saveFolderNameEdit(folder);
		} else if (e.key === 'Escape') {
			this.cancelFolderNameEdit();
		}
	};

	saveFolderNameEdit = (folder) => {
		const newName = this.state.editingFolderName.trim();
		if (newName && newName !== folder.name && this.props.onRenameSubfolder) {
			this.props.onRenameSubfolder(folder, newName);
		}
		this.setState({ editingFolderUuid: null, editingFolderName: '' });
	};

	cancelFolderNameEdit = () => {
		this.setState({ editingFolderUuid: null, editingFolderName: '' });
	};

	handleCopyClicked(media) {
		this.props.onCopyClicked(media);
	}

	humanFileSize(bytes, si) {
		var thresh = si ? 1000 : 1024;
		if (Math.abs(bytes) < thresh) {
			return bytes + ' B';
		}
		var units = si ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		var u = -1;
		do {
			bytes /= thresh;
			++u;
		} while (Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(1) + ' ' + units[u];
	}

	componentWillReceiveProps(newProps) {

		console.log(newProps.organisationuuid);
		this.setState({
			medialibraryuuid: newProps.medialibraryuuid,
			organisationuuid: newProps.organisationuuid,
			media: newProps.media || [],
			itemsSelected: newProps.itemsSelected
		});
	}

	toggleSelected(media) {
		this.props.onSelectionChanged(media, !this.getCheckedState(media));
	}

	onBeforeDragStart = () => {
		this.setState({
			isDragging: true
		});
	};

	onDragEnd = result => {
		this.setState({
			isDragging: false
		});

		if (!result.destination) {
			return;
		}

		const destId = result.destination.droppableId;

		// Dropped onto a folder drop-zone -> move the media into that folder.
		if (destId.indexOf('folder-') === 0) {
			if (this.props.onMoveMediaToFolder) {
				const media = this.state.media.find(m => m.uuid === result.draggableId);
				const folderUuid = destId.replace('folder-', '');
				if (media) {
					// If the dragged item is part of the current multi-selection, move the whole
					// selection; otherwise just the dragged item.
					const selected = this.state.itemsSelected || [];
					const isSelected = selected.some(m => m.uuid === media.uuid);
					const toMove = (isSelected && selected.length > 1) ? selected : [media];

					// Don't move anything that is still uploading or flattening — its S3 object
					// isn't settled yet, so the move could break it.
					const stillProcessing = toMove.some(m => !m.uploaded || (m.flatteningStatus && (m.flatteningStatus === 'pending' || m.flatteningStatus === 'processing')));
					if (stillProcessing) {
						if (this.dialog) {
							this.dialog.showAlert(this.props.t('TemplateMediaTable.cannot_move_processing'));
						}
						return;
					}

					this.props.onMoveMediaToFolder(toMove, folderUuid);
				}
			}
			return;
		}

		// Otherwise it's a reorder within the media list.
		if (result.destination.index === result.source.index) {
			return;
		}

		if (this.props.onDragEnd) {
			this.props.onDragEnd(result);
		}
	};

	getCheckedState(media) {
		return this.state.itemsSelected.includes(media);
	}

	handleSwitchChange(checked, media) {
		console.log('click: ' + media.uuid);
		this.props.onEnabledChanged(media, checked);
	}

	handleCheckBoxChange = event => {
		const target = event.target;

		const checked = target.checked;
		const uuid = target.name;

		const media = this.state.media.find(media => {
			return media.uuid === uuid;
		});

		this.props.onSelectionChanged(media, checked);
	};

	render() {
		const noPropagation = e => e.stopPropagation();

		const { t, medialibraryuuid, organisationuuid } = this.props;
		const subfolderBasePath = this.props.subfolderBasePath || '/studiolibraries';
		const subfolders = this.props.subfolders || [];
		const canDrop = Boolean(this.props.onMoveMediaToFolder);
		const parentFolder = this.props.parentFolder;

		// "Up a level" drop-zone (like a file manager's ".." entry) — drop media here
		// to move it into the parent folder. Also a link to navigate up.
		const parentRow = parentFolder ? (
			<Droppable droppableId={`folder-${parentFolder.uuid}`} isDropDisabled={!canDrop}>
				{(provided, snapshot) => {
					const isDropTarget = snapshot.isDraggingOver;
					const upUrl = `${subfolderBasePath}/${parentFolder.uuid}?rel=library`;
					return (
						<tbody ref={provided.innerRef} {...provided.droppableProps}>
							<tr className='subfolder-row' style={{ background: isDropTarget ? '#d9edf7' : '#f5f5f5', outline: isDropTarget ? '2px dashed #31708f' : (canDrop && this.state.isDragging ? '1px dashed #bcdff1' : 'none'), outlineOffset: '-2px' }}>
								<td width='20' />
								<td width='150'>
									<Link to={upUrl} className='thumbnail' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60px', width: '150px', marginBottom: 0, background: '#fff' }}>
										<em className='fas fa-folder-open' style={{ fontSize: '40px', color: '#31708f' }} />
									</Link>
								</td>
								<td className='hidden-xs' style={{ verticalAlign: 'middle' }}>
									<Link to={upUrl} style={{ fontWeight: 600 }}><em className='fas fa-level-up-alt' style={{ marginRight: '6px', color: '#31708f' }} /> {t('TemplateMediaTable.parent_folder')}</Link>
								</td>
								<td className='hidden-xs hidden-sm' colSpan={4} style={{ verticalAlign: 'middle', textAlign: 'center', color: '#31708f', fontWeight: 600 }}>
									{isDropTarget ? (<span>{t('TemplateMediaTable.drop_to_move_up')}</span>) : null}
								</td>
								<td align='center' width='230' style={{ verticalAlign: 'middle' }} />
							</tr>
						</tbody>
					);
				}}
			</Droppable>
		) : null;

		let folderRows = subfolders.map((folder) => {
			const folderUrl = `${subfolderBasePath}/${folder.uuid}?rel=library`;
			return (
				<Droppable droppableId={`folder-${folder.uuid}`} key={`folder-${folder.uuid}`} isDropDisabled={!canDrop}>
					{(provided, snapshot) => {
						const isDropTarget = snapshot.isDraggingOver;
						return (
							<tbody ref={provided.innerRef} {...provided.droppableProps}>
								<tr
									className='subfolder-row'
									style={{
										background: isDropTarget ? '#dff0d8' : '#fbf8ef',
										outline: isDropTarget ? '2px dashed #5cb85c' : (canDrop && this.state.isDragging ? '1px dashed #d0c9b5' : 'none'),
										outlineOffset: '-2px'
									}}
								>
									<td width='20' />
									<td width='150'>
										<Link
											to={folderUrl}
											className='thumbnail'
											style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '84px', width: '150px', marginBottom: 0, background: '#fff' }}
										>
											<em className={isDropTarget ? 'fas fa-folder-open' : 'fas fa-folder'} style={{ fontSize: '40px', color: '#f0ad4e' }} />
										</Link>
									</td>
									<td className='hidden-xs' style={{ verticalAlign: 'middle' }}>
										{this.props.onRenameSubfolder && this.state.editingFolderUuid === folder.uuid ? (
											<input
												type='text'
												className='form-control'
												value={this.state.editingFolderName}
												onChange={this.handleFolderNameChange}
												onKeyDown={(e) => this.handleFolderNameKeyDown(folder, e)}
												onBlur={() => this.saveFolderNameEdit(folder)}
												autoFocus
												style={{ width: '100%' }}
											/>
										) : (
											<Link to={folderUrl} style={{ fontWeight: 600 }}>{folder.name}</Link>
										)}
									</td>
									<td className='hidden-xs hidden-sm' colSpan={4} style={{ verticalAlign: 'middle', textAlign: 'center', color: '#3c763d', fontWeight: 600 }}>
										{isDropTarget ? (
											<span><em className='fas fa-arrow-down' /> {t('TemplateMediaTable.drop_to_move')}</span>
										) : null}
									</td>
									<td align='center' width='230' style={{ verticalAlign: 'middle' }}>
										<div className='btn-toolbar pull-right'>
											<Link to={folderUrl} className='btn btn-sm btn-default'>
												<em className='fas fa-folder-open' /> {t('TemplateMediaTable.open')}
											</Link>
											{this.props.onRenameSubfolder && (
												<TooltipButton
													className='btn-default btn-sm'
													onClick={e => this.startEditingFolder(folder, e)}
													tooltip={t('TemplateMediaTable.rename')}
												>
													<em className='fas fa-pencil-alt' />
												</TooltipButton>
											)}
											{this.props.onDeleteSubfolder && (
												<TooltipButton
													className='btn-danger btn-sm'
													onClick={e => {
														e.stopPropagation();
														this.props.onDeleteSubfolder(folder);
													}}
													tooltip={t('Dialog.delete')}
												>
													<em className='fas fa-trash' />
												</TooltipButton>
											)}
										</div>
									</td>
								</tr>
							</tbody>
						);
					}}
				</Droppable>
			);
		});

		const getItemStyle = (isDragging, draggableStyle) => ({
			userSelect: 'none',
			background: isDragging ? '#dddddd' : '',
			display: isDragging ? 'table' : '',
			...draggableStyle
		});

		const getListStyle = isDraggingOver => ({
			borderCollapse: isDraggingOver ? 'separate' : 'collapse'
		});

		let mediaRows = this.state.media.map((media, index) => {
			// Check if this is an image type (for text overlay support)
			const isImage = media.extension && ['jpg', 'jpeg', 'png', 'gif'].includes(media.extension.toLowerCase());
			const isThisSelected = (this.state.itemsSelected || []).some(m => m.uuid === media.uuid);

			return (
				<Draggable key={media.uuid} draggableId={media.uuid} index={index}>
					{(provided, snapshot) => (
						snapshot.isDragging ? (
							<tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={{ ...provided.draggableProps.style, transform: `${(provided.draggableProps.style && provided.draggableProps.style.transform) || ''} translate(${this.grabOffset.x - 24}px, ${this.grabOffset.y - 22}px)`, display: 'table', width: 'auto', height: 'auto', background: '#ffffff', boxShadow: '0 3px 12px rgba(0,0,0,0.3)', borderRadius: '4px', border: '1px solid #ccc' }}>
								<td colSpan={8} style={{ padding: '8px 14px', whiteSpace: 'nowrap' }}>
									<em className='fas fa-arrows-alt' style={{ color: '#888', marginRight: '10px' }} />
									<img src={`${config.playersBaseURL}/mediaserver/thumbnails/${organisationuuid}/${medialibraryuuid}/${media.uuid}.jpg`} height='30' style={{ verticalAlign: 'middle', marginRight: '10px', borderRadius: '3px' }} />
									<strong>{media.name}</strong>
										{(this.state.itemsSelected || []).some(m => m.uuid === media.uuid) && this.state.itemsSelected.length > 1 && (
											<span className='label label-primary' style={{ marginLeft: '10px' }}>{this.state.itemsSelected.length} {t('TemplateMediaTable.items')}</span>
										)}
								</td>
							</tr>
						) : (
						<tr
							ref={provided.innerRef}
							{...provided.draggableProps}
							{...provided.dragHandleProps}
							onMouseDownCapture={this.recordGrab}
							onClick={e => {
								e.stopPropagation();
								this.toggleSelected(media);
							}}
							style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
						>
							<td width='20' onClick={e => e.stopPropagation()}>
								<Checkbox checked={this.getCheckedState(media)} name={media.uuid} onChange={this.handleCheckBoxChange} />
							</td>
							<td width='150'>
								{media.uploaded ? (
									<div style={{ position: 'relative' }}>
										<a onClick={noPropagation} href={`${config.playersBaseURL}/mediaserver/media/${organisationuuid}/${medialibraryuuid}/${media.uuid}.${media.extension}`} className='thumbnail' target='_blank'>
											<img src={`${config.playersBaseURL}/mediaserver/thumbnails/${organisationuuid}/${medialibraryuuid}/${media.uuid}.jpg`} width='150' />
										</a>
										{media.hasTextOverlay && (
											<span
												className="label label-success"
												style={{ position: 'absolute', top: '5px', right: '5px', fontSize: '10px' }}
											>
												TEXT
											</span>
										)}
										{media.flatteningStatus && (media.flatteningStatus === 'pending' || media.flatteningStatus === 'processing') && (
											<span
												className="label label-warning"
												style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: '10px' }}
											>
												PROCESSING
											</span>
										)}
										{media.flatteningStatus === 'failed' && (
											<span
												className="label label-danger"
												style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: '10px' }}
											>
												FAILED
											</span>
										)}
									</div>
								) : (
										<img src={`${config.imagesBaseURL}/misc/processing_spinner.gif`} width='150' />
									)}
							</td>
							<td width='150' className='hidden-xs'>
								{this.props.onRenameMedia && this.state.editingMediaUuid === media.uuid ? (
									<input
										type='text'
										className='form-control'
										value={this.state.editingName}
										onChange={this.handleNameChange}
										onKeyDown={(e) => this.handleNameKeyDown(media, e)}
										onBlur={() => this.saveNameEdit(media)}
										onClick={noPropagation}
										autoFocus
										style={{ width: '100%' }}
									/>
								) : (
									<span
										onClick={this.props.onRenameMedia ? (e => this.startEditingName(media, e)) : undefined}
										style={this.props.onRenameMedia ? { cursor: 'pointer' } : undefined}
										title={this.props.onRenameMedia ? 'Click to rename' : undefined}
									>
										{media.name}
									</span>
								)}
							</td>
							<td width='75' className='hidden-xs hidden-sm'>
								<span className='label label-default'>{media.extension}</span>
							</td>
							<td width='75' className='hidden-xs hidden-sm'>
								<span className='label label-default'>{this.humanFileSize(media.filesize, true)}</span>
							</td>

							<td width='150' className='hidden-xs hidden-sm'>
								{Moment(media.updatedAt).format('YYYY-MM-DD HH:mm')}
							</td>
							<td className='hidden-xs hidden-sm'>
								{Moment(media.createdAt).format('YYYY-MM-DD HH:mm')}
							</td>

							<td align='center' width='230'>
								<div className='btn-toolbar pull-right'>
									{/* Only show text overlay button for images (jpg, png, gif), not videos */}
									{isImage && (
										<Link
											to={`/templatelibraries/${medialibraryuuid}/media/${media.uuid}/edit-text`}
											className={`btn btn-sm ${media.hasTextOverlay ? 'btn-primary' : 'btn-default'}`}
											onClick={e => e.stopPropagation()}
											title={media.hasTextOverlay ? t('TemplateMediaTable.edit_text_overlay') : t('TemplateMediaTable.add_text_overlay')}
										>
											<em className='fas fa-text-width' />
										</Link>
									)}
									<TooltipButton
										disabled={this.state.isDragging}
										className='btn-danger'
										onClick={e => {
											e.stopPropagation();
											this.props.onDeleteMedia(media);
										}}
										tooltip={t('Dialog.delete')}
									>
										<em className='fas fa-trash' />
									</TooltipButton>
								</div>
							</td>
						</tr>
						)
					)}
				</Draggable>
			);
		});

		return (
			<div className='TemplateMediaTable'>
				<Dialog
					ref={el => {
						this.dialog = el;
					}}
				/>
				<DragDropContext onBeforeDragStart={this.onBeforeDragStart} onDragEnd={this.onDragEnd}>
					<table className='table table-striped'>
				<thead>
					<tr>
						<th width='20' />
						<th width='150'>{t('TemplateMediaTable.thumbnail')}</th>
						<th width='150' className='hidden-xs'>{t('TemplateMediaTable.filename')}</th>
						<th width='75' className='hidden-xs hidden-sm'>{t('TemplateMediaTable.extension')}</th>
						<th width='100' className='hidden-xs hidden-sm'>{t('TemplateMediaTable.filesize')}</th>
						<th width='150' className='hidden-xs hidden-sm'>{t('TemplateMediaTable.updated')}</th>
						<th className='hidden-xs hidden-sm'>{t('TemplateMediaTable.uploaded')}</th>
						<th><em className='fa fa-cog' /></th>
					</tr>
				</thead>
				{parentRow}
				{folderRows}
				<Droppable droppableId='media'>
					{(provided, snapshot) => (
						<tbody ref={provided.innerRef} {...provided.droppableProps} style={getListStyle(snapshot.isDraggingOver)}>
							{mediaRows}
							{provided.placeholder}
						</tbody>
					)}
				</Droppable>
			</table>
				</DragDropContext>
			</div>
		);
	}
}

export default translate('translations')(TemplateMediaTable);
